module.exports = __webpack_public_path__ + "img/expenditureItemIcon1.2e2b3e78.png";